import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import 'moment-duration-format';

const useCountdown = (endTime: number) => {
    const initialTime = useMemo(
        () => ({
            days: '00',
            hours: '00',
            mins: '00',
            secs: '00',
            time: '00d 00h 00min',
        }),
        []
    );

    const [remainingTime, setRemainingTime] = useState(initialTime);

    const isMounted = useRef(true);

    const getTimeRemaining = useCallback(() => {
        const currentTime = moment().unix();
        const timeLeft = moment.duration((endTime - currentTime) * 1000, 'milliseconds');

        const daysLeft = formatTime(timeLeft.days());
        const hoursLeft = formatTime(timeLeft.hours());
        const minsLeft = formatTime(timeLeft.minutes());
        const secsLeft = formatTime(timeLeft.seconds());

        setRemainingTime({
            days: daysLeft,
            hours: hoursLeft,
            mins: minsLeft,
            secs: secsLeft,
            time: `${daysLeft}d ${hoursLeft}h ${minsLeft}min`,
        });
    }, [endTime]);

    const formatTime = (time: number) => ('0' + time).slice(-2);

    useEffect(() => {
        if (!endTime) return;

        if (moment() > moment.unix(endTime)) return;

        if (remainingTime.time === initialTime.time) {
            getTimeRemaining();
        }

        const interval = setInterval(() => {
            getTimeRemaining();
        }, 1000);

        return () => {
            clearInterval(interval);
            isMounted.current = false;
        };
    }, [endTime, initialTime, remainingTime, getTimeRemaining]);

    return remainingTime;
};

export default useCountdown;
